import Container from "../container/Container";
import HeaderLeft from "./HeaderLeft";
import HeaderRight from "./HeaderRight";

const DashboardHeader = () => {
  return (
    <header className="bg-white sticky py-2  top-0 border-b border-gray-100 shadow-lg z-50">
      <Container>
        <div className="flex items-center justify-between py-2 px-2 lg:px-0">
          <HeaderLeft />
          <HeaderRight />
        </div>
      </Container>
    </header>
  );
};

export default DashboardHeader;
